import axios from 'axios';
var API = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL !== undefined ? process.env.VUE_APP_BACKEND_URL : 'http://localhost:3000',
    withCredentials: true
});
export var getUsers = function (filters) {
    return API.post('/admin/users/list', filters);
};
